<tam-dialog tid="note_trigger_filter_dialog" [opened]="opened" dialogWidth="720px" contentHeight="335"
    titleName="{{'general.filter_criteria' | stringLiterals}}" (keydown.esc)="onCancelBtnClick($event)"
    class="trigger-filter-dialog-container">
    <ng-template #title>
        <span class="dialog-title">{{'general.filter_criteria' | stringLiterals}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCancelBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="body-container">
            <div class="filter-row-container" *ngFor="let row of rowItems">
                <div class="filter-field-col">
                    <kendo-combobox class="tam-dropdown col-ctrl" [data]="row.fieldCandidates" [filterable]="true"
                        [(ngModel)]="row.fieldId" textField="displayText" valueField="fieldId"
                        placeholder="{{'workflow.select_a_field' | stringLiterals}}"
                        (valueChange)="onFieldSelectionChanged(row, $event)" (filterChange)="onFilterField($event,row)">
                    </kendo-combobox>
                </div>
                <div class="filter-operator-col">
                    <kendo-combobox class="tam-dropdown col-ctrl" [data]="row.operatorCandidates"
                        [(ngModel)]="row.operator" textField="value" valueField="key"
                        placeholder="{{'workflow.select_an_operator' | stringLiterals}}">
                    </kendo-combobox>
                </div>
                <div class="filter-value-col" [ngSwitch]="row.fieldType">
                    <kendo-numerictextbox class="col-ctrl tam-textbox field-control" [(ngModel)]="row.expectedValue"
                        [step]="0" *ngSwitchCase="'number'" placeholder="{{'workflow.enter_a_value' | stringLiterals}}"
                        [format]="getNumberFormat(row)" [spinners]="false">
                    </kendo-numerictextbox>
                    <kendo-multiselect *ngSwitchCase="'entity'" [data]="currentEntityCandidates" [filterable]="true"
                        class="tam-textbox" [loading]="isEntityListLoading"
                        placeholder="{{'workflow.enter_a_value' | stringLiterals}}"
                        (filterChange)="onEntityListFilterChanged($event)" textField="shortName" valueField="id"
                        [(ngModel)]="row.expectedValue">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                            <tam-entity-dropdown-item [entity]="dataItem"></tam-entity-dropdown-item>
                        </ng-template>
                    </kendo-multiselect>
                    <input type="text" class="col-ctrl tam-textbox"
                        placeholder="{{'workflow.enter_a_value' | stringLiterals}}" [(ngModel)]="row.expectedValue"
                        *ngSwitchDefault />
                </div>
                <div class="filter-operation-col">
                    <smart-icon name="trash" (click)="onDeleteFilterRow(row)" class="light delete-btn"></smart-icon>
                </div>
            </div>
            <div class="tam-form-help" *ngIf="!isConditionConfigValid() && isSaveBtnClicked">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="bottom-toolbar" loading-spin [isLoading]="isDialogLoading" [loadingSize]="'big'">
                <!-- filter add button -->
                <div class="add-button-container" tid="section-add">
                    <smart-icon name="add-cycle" (click)="onAddFilterRow($event)" class="light"></smart-icon>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tid="cancel_filterModification" tam-button tamType="tertiary" tamSize="normal"
            class="dialog-button dialog-cancel footer-research-button cancel-filter-modification"
            (click)="onCancelBtnClick($event)">{{'general.cancel' |
            stringLiterals}}</button>
        <button tid="save_mdlModification" tam-button tamType="primary" tamSize="normal"
            class="dialog-button dialog-publish footer-research-button" (click)="onClickSaveBtn($event)">{{'general.save' |
            stringLiterals}}</button>
    </ng-template>

</tam-dialog>